import { accordionComponentOverrides } from './overrides/accordion';
import { autocompleteComponentOverrides } from './overrides/autocomplete';
import { avatarComponentOverrides } from './overrides/avatar';
import { badgeComponentOverrides } from './overrides/badge';
import { breadcrumbsComponentOverrides } from './overrides/breadcrumbs';
import { buttonComponentOverrides } from './overrides/button';
import { cardComponentOverrides } from './overrides/card';
import { checkboxComponentOverrides } from './overrides/checkbox';
import { chipComponentOverrides } from './overrides/chip';
import { containerComponentOverrides } from './overrides/container';
import { dialogComponentOverrides } from './overrides/dialog';
import { drawerComponentOverrides } from './overrides/drawer';
import { formControlComponentOverrides } from './overrides/form-control';
import { formControlLabelComponentOverrides } from './overrides/form-control-label';
import { formHelperTextComponentOverrides } from './overrides/form-helper-text';
import { formLabelComponentOverrides } from './overrides/form-label';
import { iconButtonComponentOverrides } from './overrides/icon-button';
import { inputComponentOverrides } from './overrides/input';
import { inputAdornmentComponentOverrides } from './overrides/input-adornment';
import { inputLabelComponentOverrides } from './overrides/input-label';
import { linkComponentOverrides } from './overrides/link';
import { listComponentOverrides } from './overrides/list';
import { menuComponentOverrides } from './overrides/menu';
import { nativeSelectComponentOverrides } from './overrides/native-select';
import { paginationComponentOverrides } from './overrides/pagination';
import { progressIndicatorsComponentOverrides } from './overrides/progress-indicators';
import { radioComponentOverrides } from './overrides/radio';
import { selectComponentOverrides } from './overrides/select';
import { stepperComponentOverrides } from './overrides/stepper';
import { switchComponentOverrides } from './overrides/switch';
import { tableComponentOverrides } from './overrides/table';
import { tabsComponentOverrides } from './overrides/tabs';
import { textFieldComponentOverrides } from './overrides/text-field';
import { toolbarComponentOverrides } from './overrides/toolbar';
import { tooltipComponentOverrides } from './overrides/tooltip';
import { typographyComponentOverrides } from './overrides/typography';
export const baseComponentOverrides = {
    ...accordionComponentOverrides,
    ...autocompleteComponentOverrides,
    ...avatarComponentOverrides,
    ...badgeComponentOverrides,
    ...breadcrumbsComponentOverrides,
    ...buttonComponentOverrides,
    ...cardComponentOverrides,
    ...checkboxComponentOverrides,
    ...chipComponentOverrides,
    ...containerComponentOverrides,
    ...dialogComponentOverrides,
    ...drawerComponentOverrides,
    ...checkboxComponentOverrides,
    ...formControlComponentOverrides,
    ...formControlLabelComponentOverrides,
    ...formHelperTextComponentOverrides,
    ...formLabelComponentOverrides,
    ...iconButtonComponentOverrides,
    ...inputAdornmentComponentOverrides,
    ...inputLabelComponentOverrides,
    ...inputComponentOverrides,
    ...linkComponentOverrides,
    ...listComponentOverrides,
    ...menuComponentOverrides,
    ...nativeSelectComponentOverrides,
    ...paginationComponentOverrides,
    ...progressIndicatorsComponentOverrides,
    ...radioComponentOverrides,
    ...selectComponentOverrides,
    ...stepperComponentOverrides,
    ...switchComponentOverrides,
    ...tableComponentOverrides,
    ...tabsComponentOverrides,
    ...textFieldComponentOverrides,
    ...toolbarComponentOverrides,
    ...tooltipComponentOverrides,
    ...typographyComponentOverrides,
    MuiScopedCssBaseline: {
        styleOverrides: {
            root: {
                fontSize: '1rem'
            }
        }
    }
};
